export default __webpack_public_path__ + "static/myanmar-ff5c3e6351b5863d223cbcd35a59cf4c.svg";